export const SAVE_MANAGEMENT_PARTIES = "SAVE_MANAGEMENT_PARTIES"
export const SAVE_MANAGEMENT_PARTIES_SUCCESS = 'SAVE_MANAGEMENT_PARTIES_SUCCESS'

export const GET_PARTY_TABLE_LIST = "GET_PARTY_TABLE_LIST"
export const GET_PARTY_TABLE_LIST_SUCCESS = 'GET_PARTY_TABLE_LIST_SUCCESS'

export const GET_EMPLOYEE_DROPDWOPN_LIST = "GET_EMPLOYEE_DROPDWOPN_LIST"
export const GET_EMPLOYEE_DROPDWOPN_LIST_SUCCESS = 'GET_EMPLOYEE_DROPDWOPN_LIST_SUCCESS'

export const MANAGEMENT_PARTIES_API_ERROR_ACTION = 'MANAGEMENT_PARTIES_API_ERROR_ACTION'